<app-popin-container>
  <div class="pt-5 desk:p-5">
    @if (isEstimateEmailed()) {
      @if (titleConfirmation(); as title) {
        <app-title [title]="title" size="h2" />
      }
      @if (estimateSentConfirmation(); as estimateSentConfirmation) {
        <div class="relative mt-7">
          <span [innerHtml]="estimateSentConfirmation"></span>
        </div>
      }
    } @else {
      @if (titleForm(); as title) {
        <app-title [title]="title" size="h2" />
      }
      <div class="mt-10 flex flex-col gap-y-7">
        <div class="relative">
          @let isSubmitted = isFormSubmitted();
          @let isInvalid = isFormValid().status === "KO";
          @let errors = isFormValid().errors!;
          <label class="mb-1 block font-bold" for="email">{{
            "COMPONENT.POPIN-ESTIMATION-EMAIL.MY_EMAIL_ADDRESS" | translate
          }}</label>
          <input
            (input)="onInputChange($event)"
            [value]="email()"
            class="h-7 w-full rounded-[10px] border px-4 py-5 desk:w-96"
            id="email"
            maxlength="255"
            type="email" />
          @if (isSubmitted && isInvalid && errors.email) {
            <div class="absolute -bottom-4 text-[10px] text-error">
              {{ errors.email | translate }}
            </div>
          }
        </div>
        @if (privacyPolicy(); as privacyPolicy) {
          <div class="relative">
            <span [innerHtml]="privacyPolicy | safeHtml" handleHtmlLinks></span>
          </div>
        }
        <div class="flex justify-center">
          <app-button
            (onButtonClick)="onSubmit()"
            [isLoading]="isSending()"
            [label]="'COMPONENT.POPIN-ESTIMATION-EMAIL.SEND_ESTIMATE' | translate" />
        </div>
      </div>
    }
  </div>
</app-popin-container>
